/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_avsDirectory",
                type: "address",
            },
            {
                internalType: "address",
                name: "_stakeRegistry",
                type: "address",
            },
            {
                internalType: "address",
                name: "_paymentCoordinator",
                type: "address",
            },
            {
                internalType: "address",
                name: "_delegationManager",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "OperatorDeregisteredFromAVS",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "contract IRemoteChallenger",
                name: "challenger",
                type: "address",
            },
        ],
        name: "OperatorEnrolledToChallenger",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "contract IRemoteChallenger",
                name: "challenger",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "unenrollmentStartBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "challengeDelayBlocks",
                type: "uint256",
            },
        ],
        name: "OperatorQueuedUnenrollmentFromChallenger",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "OperatorRegisteredToAVS",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "contract IRemoteChallenger",
                name: "challenger",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "unenrollmentEndBlock",
                type: "uint256",
            },
        ],
        name: "OperatorUnenrolledFromChallenger",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "avsDirectory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "challenger",
                type: "address",
            },
        ],
        name: "completeUnenrollment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_challengers",
                type: "address[]",
            },
        ],
        name: "completeUnenrollment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "deregisterOperatorFromAVS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IRemoteChallenger",
                name: "challenger",
                type: "address",
            },
        ],
        name: "enrollIntoChallenger",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IRemoteChallenger[]",
                name: "_challengers",
                type: "address[]",
            },
        ],
        name: "enrollIntoChallengers",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "freezeOperator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_operator",
                type: "address",
            },
            {
                internalType: "contract IRemoteChallenger",
                name: "_challenger",
                type: "address",
            },
        ],
        name: "getChallengerEnrollment",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum EnrollmentStatus",
                        name: "status",
                        type: "uint8",
                    },
                    {
                        internalType: "uint248",
                        name: "unenrollmentStartBlock",
                        type: "uint248",
                    },
                ],
                internalType: "struct Enrollment",
                name: "enrollment",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_operator",
                type: "address",
            },
        ],
        name: "getOperatorChallengers",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_operator",
                type: "address",
            },
        ],
        name: "getOperatorRestakedStrategies",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRestakeableStrategies",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "contract IStrategy",
                                name: "strategy",
                                type: "address",
                            },
                            {
                                internalType: "uint96",
                                name: "multiplier",
                                type: "uint96",
                            },
                        ],
                        internalType: "struct IPaymentCoordinator.StrategyAndMultiplier[]",
                        name: "strategiesAndMultipliers",
                        type: "tuple[]",
                    },
                    {
                        internalType: "contract IERC20",
                        name: "token",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "startTimestamp",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "duration",
                        type: "uint64",
                    },
                ],
                internalType: "struct IPaymentCoordinator.RangePayment[]",
                name: "rangePayments",
                type: "tuple[]",
            },
        ],
        name: "payForRange",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes32",
                        name: "salt",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "expiry",
                        type: "uint256",
                    },
                ],
                internalType: "struct ISignatureUtils.SignatureWithSaltAndExpiry",
                name: "operatorSignature",
                type: "tuple",
            },
        ],
        name: "registerOperatorToAVS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_paymentCoordinator",
                type: "address",
            },
        ],
        name: "setPaymentCoordinator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISlasher",
                name: "_slasher",
                type: "address",
            },
        ],
        name: "setSlasher",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "stakeRegistry",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IRemoteChallenger",
                name: "challenger",
                type: "address",
            },
        ],
        name: "startUnenrollment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IRemoteChallenger[]",
                name: "_challengers",
                type: "address[]",
            },
        ],
        name: "startUnenrollment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_metadataURI",
                type: "string",
            },
        ],
        name: "updateAVSMetadataURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class HyperlaneServiceManager__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_avsDirectory, _stakeRegistry, _paymentCoordinator, _delegationManager, overrides) {
        return super.deploy(_avsDirectory, _stakeRegistry, _paymentCoordinator, _delegationManager, overrides || {});
    }
    getDeployTransaction(_avsDirectory, _stakeRegistry, _paymentCoordinator, _delegationManager, overrides) {
        return super.getDeployTransaction(_avsDirectory, _stakeRegistry, _paymentCoordinator, _delegationManager, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=HyperlaneServiceManager__factory.js.map